import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import dayjs from "dayjs";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { z } from "zod";

import { useSession } from "@/hooks/@custom/useSession";
import { GLOBAL_SCHEMA } from "@/lib/zod";
import api from "@/services/api";
import { useAuth } from "@/store/apis/nextcargo";

import { Input } from "../../Input";

type DeleteUserProps = {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  cpf: string;
  birthDate: string;
};
export function DeleteDriver({ context, id, innerProps }: ContextModalProps<DeleteUserProps>) {
  const { driver } = useSession();
  const driverId = driver?.id;

  const schema = z
    .object({
      cpf: GLOBAL_SCHEMA.REQUIRED.CPF,
      birthDate: GLOBAL_SCHEMA.REQUIRED.BIRTHDAY
    })
    .superRefine((val, ctx) => {
      const cpf = val.cpf;
      const birthDate = dayjs(val.birthDate, "DD/MM/YYYY").format("YYYY-MM-DD");

      if (cpf !== innerProps.cpf) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "O CPF não coincide com os dados do usuário",
          path: ["cpf"]
        });
      }

      if (birthDate !== dayjs(innerProps.birthDate, "DD/MM/YYYY").format("YYYY-MM-DD")) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "A data de nascimento não coincide com os dados do usuário",
          path: ["birthDate"]
        });
      }
    });

  const { SignOut } = useAuth();

  const {
    control,
    formState: { isValid, isSubmitting },
    handleSubmit
  } = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      cpf: "",
      birthDate: ""
    },
    mode: "all"
  });

  const onSubmit: SubmitHandler<z.infer<typeof schema>> = async (data) => {
    const { cpf, birthDate } = data;

    try {
      // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate a delay
      const { status } = await api.delete(`/driver/app/delete/${driverId}`, {
        data: { cpf, birthDate }
      });

      if (status === 200 || status === 201 || status === 204) {
        toast.success("Conta excluida!");
        context.closeModal(id);

        setTimeout(() => {
          SignOut("driver");

          innerProps.onSuccess?.();
        }, 2000);
      }
    } catch (error) {
      toast.error("Erro ao exluir sua conta");
      console.log(error);

      const err = typeof error === "string" ? error : error instanceof Error ? error.message : "Erro desconhecido";
      innerProps.onError?.(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
      <div className="flex flex-col gap-2">
        <Input.Text maskProps={{ mask: "999.999.999-99" }} control={control} name="cpf" label="CPF" placeholder="Digite seu CPF" />
        <Input.Text maskProps={{ mask: "99/99/9999" }} control={control} name="birthDate" label="Data de Nascimento" placeholder="Digite sua data de nascimento" />
      </div>

      {/* <pre>{JSON.stringify({ cpf: watch("cpf"), birthDate: watch("birthDate"), innerProps }, null, 2)}</pre> */}

      <Button color="red" type="submit" loading={isSubmitting} disabled={!isValid}>
        Excluir
      </Button>
    </form>
  );
}
